import React, { useEffect, useState } from 'react';
import { Alert, Checkbox, Form, Input, InputNumber, Modal, Select, Switch, Tooltip } from 'antd';
import { SwitchContainer } from '../../pages/issuer/card-product';
import { TransactionType } from './TransactionType';

export type FeesFormInputs = {
  id: number;
  origin: TransactionType;
  allowed: boolean;
  // eslint-disable-next-line camelcase
  fixed_fee: number;
  fee: number;
  // eslint-disable-next-line camelcase
  tax_fee: number;
};

interface FeesCreateFormProps {
  open: boolean;
  onCreate: (values: FeesFormInputs) => void;
  onCancel: () => void;
  fee?: FeesFormInputs | undefined;
}

const ModalFees: React.FC<FeesCreateFormProps> = ({ fee, open, onCreate, onCancel }) => {
  const [form] = Form.useForm<FeesFormInputs>();
  const [allowed, setAllowed] = useState(true);

  useEffect(() => {
    if(fee !== null ) {
      form.setFieldValue("origin", fee?.origin);
      form.setFieldValue("fixed_fee", fee?.fixed_fee);
      form.setFieldValue("fee", fee?.fee);
      form.setFieldValue("tax_fee", fee?.tax_fee);
      setAllowed(fee?.allowed);
    }
  }, [fee]);

  return (
    <Modal
      open={open}
      title={fee ? 'Modificar fee' : 'Crear nuevo fee'}
      okText={fee ? 'Modificar' : 'Crear'}
      cancelText="Cancelar"
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            values.allowed = allowed;
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.error('Validate Failed:', info);
          });
      }}
    >
      <Form form={form} layout="vertical" name="form_in_modal">
        <Form.Item<FeesFormInputs>
          name={'origin'}
          label={'Origen'}
          rules={[{ required: true, message: 'Por favor seleccionar una opcion.' }]}
        >
          <Select
            placeholder="Seleccionar origen"
            showSearch
            options={Object.values(TransactionType).map((type) => ({ label: type, value: type }))}
          ></Select>
        </Form.Item>
        <Tooltip trigger={['hover']} title={"Monto fijo sobre la transacción"} placement="topLeft">
          <Form.Item<FeesFormInputs>
            name={'fixed_fee'}
            label={'Impuesto fijo'}
            rules={[{ required: true, message: 'Por favor ingresar un impuesto fijo.' }]}
          >
            <InputNumber<number>
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
              }
              parser={(value) =>
                value?.replace(/\$\s?|(\.*)/g, '').replace(/\./g, '') as unknown as number
              }
              style={{ width: '100%' }}
              controls={false}
            />
          </Form.Item>
        </Tooltip>
        <Tooltip trigger={['hover']} title={"Porcentual correspondiente al IVA"} placement="topLeft">
          <Form.Item<FeesFormInputs>
            name={'fee'}
            label={'IVA'}
            rules={[{ required: true, message: 'Por favor ingresar un valor para el IVA.' }]}
          >
            <Input />
          </Form.Item>
        </Tooltip>
        <Tooltip trigger={['hover']} title={"Porcentual sobre la transacción"} placement="topLeft">
          <Form.Item<FeesFormInputs>
            name={'tax_fee'}
            label={'Impuesto libre'}
            rules={[{ required: true, message: 'Por favor ingresar un impuesto libre.' }]}
          >
            <Input />
          </Form.Item>
        </Tooltip>
        <Form.Item<FeesFormInputs>
          name={'allowed'}
          label={"Desea habilitarlo?"}
          layout={"horizontal"}
        >
          <Checkbox checked={allowed} onChange={() => setAllowed(!allowed)} />
        </Form.Item>
        <Alert
          message="Ejemplo"
          description="Sobre una transacción de origen ATM de $1,000 con un Impuesto Fijo de $350, el IVA en 21% ($77,70) y un fee variable del %2 ($20), El valor final se refleja en $1,447,70"
          type="info"
          showIcon
          closable
        />
      </Form>
    </Modal>
  );
};

export default ModalFees;
